import { parseStringPromise } from "xml2js";
import axios from "axios";
import { iStaffBaseURL } from "../../constants/Urls";
import { notify } from "../../functions/function";
import { axiosTimeout } from "../../constants/Axios";

export const fetchPlacementsFromOurServer = async (userToken) => {
  const requestHeader = {
    headers: {
      Authorization: "Token " + userToken,
    },
    timeout: axiosTimeout,
  };

  return await axios
    .get(iStaffBaseURL + "/handler/placements/", requestHeader)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      console.log("There was an error in the fetchUserPlacements reducer");
      throw new Error("There was an error reaching our server");
    });
};

/* 
NB
* A SHIFT is from DataSavvy.
* A PLACEMENT is internal to our system. It has a different definition.
*/
export const getEmployeePlacementsDataSavvy = async (
  apiKey,
  apiPassword,
  companyId,
  employeeId
) => {
  const response = await fetch(`/searchme.asmx/GetEmployeeShifts`, {
    method: "POST",
    credentials: "include",
    /* Must use x-www-form-urlencoded body */
    body: new URLSearchParams({
      CompanyID: companyId,
      APIKey: apiKey,
      APIPassword: apiPassword,
      EmployeeID: employeeId,
    }),
  });

  if (!response.ok) {
    console.log(response.data);
    throw Error("Error accessing DataSavvy!");
  }

  const data = await response.text();
  const convertedXml = await parseStringPromise(data);

  return convertedXml;
};

/* We need a save way to retrieve an element from an Array in case the datatype changes. */
function sA(oneElementArray) {
  if (oneElementArray.constructor === Array) {
    return oneElementArray[0];
  } else {
    return oneElementArray;
  }
}

export function exists(shift, placements) {
  return placements.find((p) => {
    return p.iStaff_id.toString() === sA(shift.ShiftID).toString();
  });
}

/* Check if an employee has been invited to this placement in the past. */
function employeePrevInv(employee, foundPlacement) {
  if (!foundPlacement.previous_invites) {
    return false;
  }

  let prevEmployeeArr = foundPlacement.previous_invites.split(",");
  for (let idx in prevEmployeeArr) {
    if (parseInt(prevEmployeeArr[idx]) === employee.user.id) {
      return true;
    }
  }
}

/* Mutate PUT array */
function update(shift, employees, foundPlacement, PUT, addLog) {
  let employeeListedOnDataSavvy = employees.find(
    (e) => e.istaff_id.toString() === sA(shift.EmployeeID)
  );
  if (employeePrevInv(employeeListedOnDataSavvy, foundPlacement)) {
    /* Don't warn user of ignored employee update - they will see unassigned placements in the placements page. */
    /* addLog("ERROR", `Didn't add ${shift.Fullname} to ShiftID ${shift.ShiftID}. They have already been invited.`) */
    return;
  }

  if (!foundPlacement.client) {
    addLog(
      "ERROR",
      `Failed updating a new placement. ${shift.ClientName} don't have a valid iStaff ID. SHIFT ID: ${shift.ShiftID}`
    );
    return;
  }

  PUT.push({
    id: foundPlacement.id,
    iStaff_id: sA(shift.ShiftID),
    start_time: sA(shift.StartTime),
    end_time: sA(shift.EndTime),
    location: foundPlacement.client.company_address
      ? foundPlacement.client.company_address
      : "",
    handler: foundPlacement.handler.id,
    client: foundPlacement.client.id,
    employee: employeeListedOnDataSavvy ? employeeListedOnDataSavvy.id : null,
    is_assigned: true,
    is_accepted: foundPlacement.is_accepted,
    trade: sA(shift.Title),
  });
}

/* Mutate POST array */
function create(shift, clients, employeeInternalId, handlerId, POST, addLog) {
  let client = clients.find((c) => c.istaff_id === shift.ClientID[0]);

  if (!client) {
    addLog(
      "ERROR",
      `Failed creating a new placement. ${shift.ClientName} don't have a valid iStaff ID yet`
    );
    return;
  }
  POST.push({
    iStaff_id: sA(shift.ShiftID),
    start_time: sA(shift.StartTime),
    end_time: sA(shift.EndTime),
    location: client.company_address ? client.company_address : "",
    handler: handlerId,
    client: client.id,
    employee: employeeInternalId,
    is_assigned: true,
    is_accepted: false,
    trade: sA(shift.Title),
  });
}

/* This is our main controller for extracting from DataSavvy. */
export const extractAndSetPlacements = async (
  employees,
  clients,
  placements,
  apiKey,
  apiPassword,
  companyId,
  handlerId,
  addLog
) => {
  /* Array of placements to either create or update */
  var POST = [];
  var PUT = [];

  for (let idx in employees) {
    let employee = employees[idx];

    if (employee.istaff_id === "Unassigned") {
      addLog(
        "ERROR",
        `Failed updating ${employee.user.first_name} ${employee.user.last_name}. They don't have an iStaff ID yet`
      );
      continue;
    } else {
      addLog(
        "SUCCESS",
        `updating ${employee.user.first_name} ${employee.user.last_name}`
      );
    }

    let employeeId = employee.istaff_id;
    try {
      var dataSavvyShifts = await getEmployeePlacementsDataSavvy(
        apiKey,
        apiPassword,
        companyId,
        employeeId
      );
    } catch (e) {
      notify(
        "ERROR",
        "There was an error reaching DataSavvy. Please try again",
        "danger"
      );
      return [[], []];
    }

    if (!dataSavvyShifts.ArrayOfShift) {
      return [[], []];
    }

    var shifts = dataSavvyShifts.ArrayOfShift.Shift;

    if (!shifts?.length) {
      continue;
    }

    for (let y in shifts) {
      let foundPlacement = exists(shifts[y], placements);
      if (foundPlacement) {
        update(shifts[y], employees, foundPlacement, PUT, addLog);
      } else {
        create(shifts[y], clients, employee.id, handlerId, POST, addLog);
      }
    }
  }

  return [POST, PUT];
};

export const createNewPlacements = async (POST, userToken, addLog) => {
  axios
    .post(iStaffBaseURL + "/handler/placements/", POST, {
      headers: { Authorization: "Token " + userToken },
    })
    .then((res) => {
      addLog(
        "SUCCESS",
        `${POST.length} new placements successfully created in our system.`
      );
    })
    .catch((err) => {
      addLog(
        "ERROR",
        "There was an error CREATING in the server. Please try this process again."
      );
    });
};

export const updatePlacements = (PUT, userToken, addLog) => {
  axios
    .put(iStaffBaseURL + "/handler/placements/", PUT, {
      headers: { Authorization: "Token " + userToken },
    })
    .then((res) => {
      addLog(
        "SUCCESS",
        `${PUT.length} placements successfully updated in our system.`
      );
    })
    .catch((err) => {
      addLog(
        "ERROR",
        "There was an error UPDATING in the server. Please try this process again."
      );
    });
};
